import React from 'react';
import {
  Grid,
  Typography,
  Box,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import EventIcon from '@material-ui/icons/Event';
import DescriptionIcon from '@material-ui/icons/Description';
import PlaceIcon from '@material-ui/icons/Place';
import PublicIcon from '@material-ui/icons/Public';
import './DashboardSummary.css';

export default function DashboardSummary({ summary }) {
  if (!summary) return null;

  return (
    <Box mb={4}>
      <Box mb={2}><Typography style={{ fontSize: '1.3rem', fontFamily: 'Kanit, sans-serif' }}>Dashboard ระบบเหตุการณ์สถานการณ์น้ำ</Typography></Box>
      <Grid container spacing={3} justifyContent="space-evenly">
        {/* TOTAL EVENTS */}
        <Grid item xs={12} sm={6} md={3}>
          <Box display="flex" alignItems="center" className="stat-card primary" style={{ backgroundColor: '#03337F' }}>
            <EventIcon style={{ color: 'white', fontSize: '2.5rem', margin: 10 }} />
            <div>
              <Typography variant="h6" color="white">
                เหตุการณ์
              </Typography>
              <Typography variant="h3">
                {summary.total_events}
              </Typography>
            </div>
          </Box>
        </Grid>

        {/* TOTAL REPORTS */}
        <Grid item xs={12} sm={6} md={3}>
          <Box display="flex" alignItems="center" className="stat-card secondary" style={{ backgroundColor: '#36b9cc' }}>
            <DescriptionIcon style={{ color: 'white', fontSize: '2.5rem', margin: 10 }} />
            <div>
              <Typography variant="h6" color="white">
                เหตุการณ์ย่อย
              </Typography>
              <Typography variant="h3">
                {summary.total_reports}
              </Typography>
            </div>
          </Box>
        </Grid>

        {/* TOTAL AREAS */}
        <Grid item xs={12} sm={6} md={3}>
          <Box display="flex" alignItems="center" className="stat-card tertiary" style={{ backgroundColor: '#10b981' }}>
            <PlaceIcon style={{ color: 'white', fontSize: '2.5rem', margin: 10 }} />
            <div>
              <Typography variant="h6" color="white">
                จังหวัดที่เกี่ยวข้อง
              </Typography>
              <Typography variant="h3" color="white">
                {summary.total_areas}
              </Typography>
            </div>
          </Box>
        </Grid>

        {/* STATUS */}
        <Grid item xs={12} sm={6} md={3}>
          <Box display="block" alignItems="center" className="stat-card" style={{ backgroundColor: '#fb923c' }}>
            <div>
              <Typography variant="h6" color="white">
                สถานะเหตุการณ์
              </Typography>
              {/* Public */}
              <Box display="flex" alignItems="center">
                <PublicIcon style={{ marginRight: 6, color: 'white', fontSize: 24 }} />
                <Typography variant="body2" color="white" style={{ fontSize: '18px' }}>
                  สาธารณะ:
                  {summary.status.public || 0}
                </Typography>
              </Box>
            </div>
          </Box>
        </Grid>

      </Grid>
    </Box>
  );
}
DashboardSummary.propTypes = {
  summary: PropTypes.shape({
    total_events: PropTypes.number.isRequired,
    total_reports: PropTypes.number.isRequired,
    total_areas: PropTypes.number.isRequired,
    status: PropTypes.shape({
      public: PropTypes.number,
      active: PropTypes.number,
      draft: PropTypes.number,
    }).isRequired,
  }).isRequired,
};
